import React from 'react';
import { Button } from '../ui/Button';
import { Check, ShieldCheck, Truck } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-192">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-193">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-3xl" data-id="element-194" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-emerald-500 rounded-full blur-3xl" data-id="element-195" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-196">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-197">
          Take Back Your Sleep Now
        </h2>
        <p className="text-2xl text-blue-100 mb-12" data-id="element-198">
          Try Flow Regen for a full 60 nights. If you are not waking up less,
          feeling more rested, or simply are not impressed, contact us for a
          full refund.
        </p>

        <div className="bg-slate-800 text-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-2xl mx-auto transform hover:scale-105 transition-transform duration-300 border border-slate-700" data-id="element-199">
          <div className="inline-block bg-red-900/30 text-red-300 px-4 py-1 rounded-full text-[19px] font-bold uppercase tracking-wide mb-6 border border-red-700/50" data-id="element-200">
            Limited Batch • European Sourcing
          </div>

          {/* Product Image */}
          <div className="mb-8 flex items-center justify-center" data-id="element-201">
            <img src="https://cdn.magicpatterns.com/uploads/9oCX1vHKCugLQ5QKm5q23s/13.svg" alt="Flow Regen Prostate Support Drops" className="w-full max-w-sm h-auto" data-id="element-202" />
          </div>

          <h3 className="text-3xl font-bold mb-2" data-id="element-203">Exclusive Online Offer</h3>
          <div className="text-5xl font-bold text-[#e6b500] mb-2" data-id="element-204">Save 64%</div>
          <p className="text-slate-400 text-xl mb-8" data-id="element-205">on the 6-bottle bundle</p>

          <ul className="text-left space-y-4 mb-8 bg-slate-900/50 p-6 rounded-xl border border-slate-700" data-id="element-206">
            <li className="flex items-start" data-id="element-207">
              <Check className="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-208" />
              <span className="text-[19px] font-medium text-slate-300" data-id="element-209">
                Pelvic congestion takes time to resolve — consistency is key.
              </span>
            </li>
            <li className="flex items-start" data-id="element-210">
              <Check className="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-211" />
              <span className="text-[19px] font-medium text-slate-300" data-id="element-212">
                Lock in today's pricing against future ingredient costs.
              </span>
            </li>
            <li className="flex items-start" data-id="element-213">
              <Check className="w-6 h-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-214" />
              <span className="text-[19px] font-medium text-slate-300" data-id="element-215">
                One-time purchase • No automatic subscriptions
              </span>
            </li>
          </ul>

          <Button fullWidth size="lg" variant="primary" onClick={() => window.location.href = 'https://arella.store/products/flow-regen'} className="text-2xl py-6 shadow-xl shadow-[#e6b500]/20 mb-4" data-id="element-216">
            CLAIM YOUR DISCOUNT NOW
          </Button>

          <div className="flex items-center justify-center space-x-4 text-[19px] text-slate-400 font-medium" data-id="element-217">
            <span className="flex items-center" data-id="element-218">
              <ShieldCheck className="w-5 h-5 mr-1" data-id="element-219" /> 60-Day Guarantee
            </span>
            <span className="flex items-center" data-id="element-220">
              <Truck className="w-5 h-5 mr-1" data-id="element-221" /> Free Shipping on 3+ Bottles
            </span>
          </div>
        </div>
      </div>
    </section>;
}